import React, { useEffect, useMemo, useState } from 'react';
import { Slide } from 'react-slideshow-image';
import { Link } from 'react-router-dom';
import 'react-slideshow-image/dist/styles.css';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import styles from './CandidatePortal.module.scss';
import Airswift from '../../Assets/images/Airswift Primary Logo (Black Text).png';
import AirswiftW from '../../Assets/images/Airswift Primary Logo (White Text).png';
import workimg from '../../Assets/images/landing-1.jpg';
import Linkedin from '../../Assets/images/LinkedIn.png';
import standout from '../../Assets/images/Stand-out.png';
import summary from '../../Assets/images/Summary.png';
import timejob from '../../Assets/images/Time-job.png';
import tick from '../../Assets/images/Group 62.png';
import DashboardButtonCard from '../../Components/common/Cards/DashboardButtonCard/DashboardButtonCard';
import { dashboardCards, mobileWidth } from '../../utils/constants';
import { getCookie } from '../../utils/helpers';
import configData from '../../config.json';
import { useWindowSize } from '../../utils/hooks';

import('../../scss/react-slider-indicator.css');

export function CompletedProfile() {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user.profile?.IsProfileCompleted);
  let completedProfile = localStorage.getItem('userProfileCompleted') === 'true';

  useEffect(() => {
    completedProfile = localStorage.getItem('userProfileCompleted') === 'true';
  }, [user]);

  if (completedProfile) {
    return (
      <div className={` p-5 pt-4 ${styles.landing_buttons}`}>
        <h4>{t('dashboard.profile.builder')}</h4>
        <img src={tick} alt="tick" className="pb-2" width="40px" />
        <p>{t('dashboard.profile.congrats')}</p>
        <Link to="/my-profile" className="pt-4 d-inline-block">
          <h6>{t('dashboard.profile.view')}</h6>
        </Link>
      </div>
    );
  }
  return (
    <div className={` p-5 ${styles.landing_buttons}`}>
      <h4>{t('dashboard.profile.builder')}</h4>
      <p>{t('dashboard.profile.update')}</p>
      <Link to="/dashboard/profile-builder-one" className="pt-4 d-inline-block">
        <h6>{t('dashboard.profile.continue')}</h6>
      </Link>
    </div>
  );
}

export function Slideshow() {
  const size = useWindowSize();
  const { t } = useTranslation();

  const firstName = useSelector((state) => state.user.profile?.FirstName);
  const firstNameFromStorage = localStorage.getItem('AirswiftFirstName');

  return (
    <Slide indicators={size.width <= mobileWidth} duration="10000" arrows={size.width > mobileWidth}>
      <div className={`each-slide-effect ${styles.landing_hero}`}>
        <img src={workimg} alt="t3" className={`pb-3 ${styles.bg_image}`} />
        <div className={styles.floating_landing}>
          <h1>
            {t('dashboard.slider.hello')}, {firstName || firstNameFromStorage}
          </h1>
          <h4>
            <Trans i18nKey="dashboard.slider.welcome">
              Welcome to your Airswift self-service portal. <br />
              We're glad you're here...
            </Trans>
          </h4>
        </div>
      </div>
      <div className={`each-slide-effect ${styles.landing_hero}`}>
        <img src={standout} alt="t3" className={`pb-3 ${styles.bg_image}`} />
        <div className={styles.floating_logo}>
          <img src={Airswift} alt="t3" className="p-3" />
        </div>
        <div className={styles.floating_content}>
          <h3>{t('dashboard.slider.resume')}</h3>
          <h4>{t('dashboard.slider.jobseeker')}</h4>
          <a
            href="https://www.airswift.com/blog/resume-writing-tips-how-can-job-seekers-stand-out"
            target="_blank"
            className={styles.floating_read_more_content}
            rel="noreferrer"
          >
            {t('dashboard.slider.readmore')}
          </a>
        </div>
      </div>
      <div className={`each-slide-effect ${styles.landing_hero}`}>
        <img src={Linkedin} alt="t3" className={`pb-3 ${styles.bg_image}`} />
        <div className={`${styles.floating_content_dark} ${styles.floating_content_2}`}>
          <h3>{t('dashboard.slider.standout')}</h3>
          <h4>{t('dashboard.slider.linkedin')}</h4>
          <a
            href="https://www.airswift.com/blog/how-to-create-a-standout-linkedin-profile"
            target="_blank"
            className={styles.floating_read_more_content}
            rel="noreferrer"
          >
            {t('slider.readmore')}
          </a>
        </div>
        <div className={`${styles.floating_logo_left}`}>
          <img src={AirswiftW} alt="t3" className="p-3" />
        </div>
      </div>
      <div className={`each-slide-effect ${styles.landing_hero}`}>
        <img src={summary} alt="t3" className={`pb-3 ${styles.bg_image}`} />
        <div className={styles.floating_logo}>
          <img src={Airswift} alt="t3" className="p-3" />
        </div>
        <div className={styles.floating_content}>
          <h3>{t('dashboard.slider.optimize')}</h3>
          <h4>{t('dashboard.slider.impression')}</h4>
          <a
            href="https://www.airswift.com/blog/optimize-your-resume-summary"
            target="_blank"
            className={styles.floating_read_more_content}
            rel="noreferrer"
          >
            {t('dashboard.slider.readmore')}
          </a>
        </div>
      </div>
      <div className={`each-slide-effect ${styles.landing_hero}`}>
        <img src={timejob} alt="t3" className={`pb-3 ${styles.bg_image}`} />
        <div className={styles.floating_content_dark}>
          <h4>{t('dashboard.slider.careerchange')}</h4>
          <a
            href="https://www.airswift.com/blog/how-to-know-when-its-the-right-time-for-a-career-change"
            target="_blank"
            className={styles.floating_read_more_content}
            rel="noreferrer"
          >
            {t('dashboard.slider.readmore')}
          </a>
        </div>
        <div className={styles.floating_logo_left}>
          <img src={AirswiftW} alt="t3" className="p-3" />
        </div>
      </div>
    </Slide>
  );
}

export function Dashboard() {
  const user = useSelector((state) => state.user.profile);
  const { t } = useTranslation();
  const dashboardTexts = useMemo(() => dashboardCards(t), [t]);

  const [accessToOnboarding, setAccessToOnboarding] = useState(
    getCookie(configData.TIFO_ONBOARDING_KEY)
      ? getCookie(configData.TIFO_ONBOARDING_KEY) === configData.TIFO_ONBOARDING_VALUE
      : false
  );

  useEffect(() => {
    setInterval(
      () =>
        setAccessToOnboarding(
          getCookie(configData.TIFO_ONBOARDING_KEY)
            ? getCookie(configData.TIFO_ONBOARDING_KEY) === configData.TIFO_ONBOARDING_VALUE
            : false
        ),
      1000
    );
  }, []);

  return (
    <div className="container-fluid px-sm-5 p-sm-4 Dashboard">
      <div className="row">
        <div className="col-md-12 p-0 text-center">
          {user?.Id ? (
            <Slideshow />
          ) : (
            <div className={styles.landing_hero}>
              <Skeleton variant="rectangular" className={styles.slideSkeleton} />
            </div>
          )}
        </div>
      </div>
      {user?.Id ? (
        <div className={`${styles.buttonContainer} pt-4 pb-4 px-1`}>
          <CompletedProfile />
          <DashboardButtonCard cardInfo={dashboardTexts.JOBS} />
          {accessToOnboarding && <DashboardButtonCard cardInfo={dashboardTexts.ONBOARDING} />}
        </div>
      ) : (
        <div className={`${styles.buttonContainer} pt-4 pb-4 px-1`}>
          <div className={` p-5 pt-4 ${styles.landing_buttons}`}>
            <Skeleton animation="wave" variant="rectangular" className={styles.slideSkeleton} />
          </div>
          <div className={` p-5 pt-4 ${styles.landing_buttons}`}>
            <Skeleton animation="wave" variant="rectangular" className={styles.slideSkeleton} />
          </div>
          <div className={` p-5 pt-4 ${styles.landing_buttons}`}>
            <Skeleton animation="wave" variant="rectangular" className={styles.slideSkeleton} />
          </div>
        </div>
      )}
    </div>
  );
}
